import { Component, Inject, OnInit , EventEmitter} from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DBasicosParametricasServicios, DValorPeriodico, DValorDominio } from '@dian/api-basicos-parametricas';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_143';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Deudas hipotecarias', listHelp: ['167'/*,'252','253','173','254','168'*/] }
  /*{ text: "2", active: false, completed: false, tooltip: 'Contrato de leasing', listHelp: ['172'] },
  { text: "3", active: false, completed: false, tooltip: 'Deudas Libre Inversión', listHelp: ['173'] },
  { text: "4", active: false, completed: false, tooltip: 'Deudas por tarjeta de crédito', listHelp: ['174'] },
  { text: "5", active: false, completed: false, tooltip: 'Otras  deudas', listHelp: ['175'] }*/
];

const tableStructure = [   
  {id: 'desc', title: 'Descripción'}, 
  {id: 'origen', title: 'Origen de la información'}, 
  {id: 'adquisicionNombre', title: 'Tipo de deuda'}, 
  {id: 'valDeclarar', title: 'Valor a declarar'},
];


class Form1 {
  id: number;
  idSugerida:number;
  desc: string;
  origen:string;
  adquisicion:string;
  adquisicionNombre:string; 
  valDeclarar:string;


  reportante:string;
  mejoras:string;
}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-patrimonio-deuda-nacional-modal',
  templateUrl: './patrimonio-deuda-nacional-modal.component.html',
  styleUrls: ['./patrimonio-deuda-nacional-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    DValorDominio
  ]
})
export class PatrimonioDeudaNacionalModalComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public lstAnios: number[] = [];
  public lisTipDeudaMonNal: DValorDominio[] = [];

  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA; 
  
  
  saveModel = new EventEmitter();
  public showSave:boolean;
  //listaModoAdquisicion:any;
  
  model:DDocumento;
  mensajeTabla = "Algunos campos fueron sugeridos por el sistema con base en su información exógena. Edite, agregue o elimine según su situación económica.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  
  constructor(
    public dutilidades:DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio, 
    public dialogRef: MatDialogRef<PatrimonioDeudaNacionalModalComponent>,
    private _sugeridaSingletonService: SugeridaSingletonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    this.model = this.data.model;
    console.log(this.model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeSugerida();
    //this.validateBtnRightActive();
    this.validateShowSave();

    this.lisTipDeudaMonNal.sort((a, b) => Number(a.valor) - Number(b.valor));
    console.log("Lista orden Mon Nacional= ",this.lisTipDeudaMonNal);
  }

  protected controlStep(direction: DirectionType): void {
  
  }
  
  protected inicializeForm() {
    this.modelForm = new Form1();
    this.modelForm.id = 0;    
    this.modelForm.desc = "";
    this.modelForm.adquisicionNombre="";
    this.modelForm.origen = "";
    this.modelForm.valDeclarar = "0";    
    this.modelForm.idSugerida = 0;    
    this.modelForm.adquisicion="0";
    this.modelForm.reportante="";
         
  }

  protected inicializeModelo() {
    if (this.model.doc.cuerpo.cc_id_252 == undefined) {
      
      this.model.doc.cuerpo.cc_id_173 = [];   //Origen
      this.model.doc.cuerpo.cc_id_252 = [];   //Descripcion Acreedor
      this.model.doc.cuerpo.cc_id_253 = [];   //Tipo Deuda
      this.model.doc.cuerpo.cc_id_254 = [];   //valDeclarar
      this.model.doc.cuerpo.cs_id_168 = "0";  //Total Suma      
    }
  }

  public operacionCs168(){ 
    let suma = "0";
    for(let i=0; i<this.dataSourceBody.length; i++){
      suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valDeclarar, suma);
    }
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma, "0")) {
      suma = "0";
    }
    if(suma)
      this.model.doc.cuerpo.cs_id_168 = suma;
    else
      this.model.doc.cuerpo.cs_id_168 = '0'; 
  }


  //////////////////////

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_252.length; i++){
      this.modelForm.id=i;
      this.modelForm.desc=this.model.doc.cuerpo.cc_id_252[i].v;
      if(this.lisTipDeudaMonNal && this.lisTipDeudaMonNal.length>0){
        const tipoDeuda = this.lisTipDeudaMonNal.find(item => item.valor == this.model.doc.cuerpo.cc_id_253[i].v);
        this.modelForm.adquisicionNombre = tipoDeuda ? tipoDeuda.nombre : '';
      }
      /* if(this.lisTipDeudaMonNal[this.model.doc.cuerpo.cc_id_253[i].v-1])
        this.modelForm.adquisicionNombre=this.lisTipDeudaMonNal[this.model.doc.cuerpo.cc_id_253[i].v-1].nombre; */
      this.modelForm.adquisicion=this.model.doc.cuerpo.cc_id_253[i].v; 
      this.modelForm.origen=this.model.doc.cuerpo.cc_id_173[i].v;
      this.modelForm.valDeclarar=this.model.doc.cuerpo.cc_id_254[i].v;

      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

protected initializeTablaDesdeSugerida()
{
  let indexModel = this.model.doc.cuerpo.cc_id_252.length;
  
  if(indexModel==0){
    const fieldsRecovery = ['VAR_2151','VAR_2152','VAR_2153','VAR_4418','VAR_2155','VAR_2157','VAR_4417','VAR_2380','VAR_4419','VAR_1871'];
    //Se elimina por solicitud funcional 11-09-2024,'VAR_2256_4'];
    const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);
    console.log(resData);
  
    if(resData)
    {
      for(let i=0; i<resData.length; i++){
        for(let j=0; j<resData[i].item.value.length; j++){
          //const existeValor = this.model.doc.cuerpo.cc_id_252.some(item => item.v === this.data.sugerida[i].desc
          //if(!existeValor){
            this.modelForm.id=indexModel;
            this.modelForm.desc=resData[i].item.numNitInformante[j]+"/"+resData[i].item.nomRazonSocialInformante[j];
            //console.log(this.data.sugerida[i]);
            console.log(this.lisTipDeudaMonNal);
            this.modelForm.adquisicion= "6";
            this.modelForm.adquisicionNombre= this.lisTipDeudaMonNal[Number(this.modelForm.adquisicion)-1].nombre; 
            this.modelForm.origen="0";
            //this.modelForm.idSugerida=this.data.sugerida[i].idSugerida;
            //this.modelForm.reportante=this.data.sugerida[i].reportante;
            this.modelForm.valDeclarar=String(resData[i].item.value[j]);

            //VAR_1871 Solo se incluye si es viene negativo, aunque debe cambiarse a signo positivo
            let agregar:boolean = true;
            if (resData[i].key=="VAR_1871") {
              if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, this.modelForm.valDeclarar, "0")){
                this.modelForm.valDeclarar = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelForm.valDeclarar, "-1",true);
              }else{
                agregar=false;
              }
            }
            if(agregar){
              this.redondearFormData();
              this.dataSourceBody.push(this.modelForm);
              indexModel++;
            }
            this.inicializeForm();
          //}
        }
      }
      
    }
  }
  this.operacionCs168();
}

  public editModeloDesdeForm(){   
    
    this.model.doc.cuerpo.cc_id_252[this.modelForm.id].v=this.modelForm.desc;
    this.model.doc.cuerpo.cc_id_253[this.modelForm.id].v=this.modelForm.adquisicion.toString();
    this.model.doc.cuerpo.cc_id_173[this.modelForm.id].v=this.modelForm.origen.toString();    
    this.model.doc.cuerpo.cc_id_254[this.modelForm.id].v=this.modelForm.valDeclarar.toString();

  }

  public addToModeloDesdeForm(){
    let i= this.modelForm.id+1;    
    this.model.doc.cuerpo.cc_id_252.push({it: i, v:this.modelForm.desc});
    this.model.doc.cuerpo.cc_id_253.push({it: i, v:this.modelForm.adquisicion.toString()});
    this.model.doc.cuerpo.cc_id_173.push({it: i, v:this.modelForm.origen.toString()});    
    this.model.doc.cuerpo.cc_id_254.push({it: i, v:this.modelForm.valDeclarar.toString()});

  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_252.splice(index,1);
    this.model.doc.cuerpo.cc_id_253.splice(index,1);
    this.model.doc.cuerpo.cc_id_173.splice(index,1);
    this.model.doc.cuerpo.cc_id_254.splice(index,1);

    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_252.length;i++){
      this.model.doc.cuerpo.cc_id_252[i].it=i+1;
      this.model.doc.cuerpo.cc_id_253[i].it=i+1;
      this.model.doc.cuerpo.cc_id_173[i].it=i+1;
      this.model.doc.cuerpo.cc_id_254[i].it=i+1;     
    }
  }

  public validateFormCompleted():boolean{
    return this.modelForm.desc==undefined || this.modelForm.desc==null || this.modelForm.desc.trim()=="" ||
          this.modelForm.adquisicion==undefined || this.modelForm.adquisicion==null ||
          this.modelForm.origen==undefined || this.modelForm.origen==null
  }

  public redondearFormData(){       
    this.modelForm.valDeclarar=this.dutilidades.redondearValorMoneda(this.modelForm.valDeclarar.toString(),true);
  }

  
  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
     // this.modelForm.origen = (this.modelForm.origen == "0" || this.modelForm.origen == "1") && this.operacionTabla==this.OPERACION_EDITAR ? "1" : "2";
      if (this.operacionTabla==this.OPERACION_EDITAR){
        /*
        const existeValor = this.model.doc.cuerpo.cc_id_252.some(item => item.v === this.modelForm.desc);
      
        if(this.modelForm.origen=="2" || this.modelForm.origen=="1" || (existeValor && this.modelForm.origen=="0")){ //editando contribuyente o editando sugerida
          this.modelForm.origen = this.modelForm.origen=="0" && this.modelForm.origen=="0" ? "1" : this.modelForm.origen;
          //this.editModeloDesdeForm();
        }else if(this.modelForm.origen=="0"){ //editando sugerida
          this.modelForm.origen = "1";
          this.modelForm.id = this.model.doc.cuerpo.cc_id_252.length;
          //this.addToModeloDesdeForm();
        }*/
        this.modelForm.adquisicionNombre = this.lisTipDeudaMonNal[Number(this.modelForm.adquisicion)-1].nombre;
        if(this.modelForm.origen=="0"){ 
          this.modelForm.origen = "1";
        }
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });
       // this.editModeloDesdeForm();      
      }else if (this.operacionTabla==this.OPERACION_AGREGAR){ //agregando nuevo por el contribuyente
        this.modelForm.id = this.model.doc.cuerpo.cc_id_252.length;
        this.modelForm.origen = "2";
        this.modelForm.reportante = "Contribuyente";
        this.modelForm.adquisicionNombre = this.lisTipDeudaMonNal[Number(this.modelForm.adquisicion)-1].nombre;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs168();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs168();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
      //this.reloadSelArticulos(true);
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  
  ///////////////////////


/* 
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cs_id_171 == undefined)this.model.doc.cuerpo.cs_id_171="0";
    if(this.model.doc.cuerpo.cs_id_172 == undefined)this.model.doc.cuerpo.cs_id_172="0";
    if(this.model.doc.cuerpo.cs_id_173 == undefined)this.model.doc.cuerpo.cs_id_173="0";
    if(this.model.doc.cuerpo.cs_id_174 == undefined)this.model.doc.cuerpo.cs_id_174="0";
    if(this.model.doc.cuerpo.cs_id_175 == undefined)this.model.doc.cuerpo.cs_id_175="0";
  }

  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
      case 171:
        this.operacionCs171();
        break;
      case 172:
        this.operacionCs172();
        break;
      case 173:
        this.operacionCs173();
        break;
      case 174:
        this.operacionCs174();
        break;
      case 175:
        this.operacionCs175();
        break;
    }
    if(soloEstaCasilla)return;

    //Operaciones
    let resultado = "0";
    
    //C148=C171+C172+C173+C174+C175; 
    resultado = "0";
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.model.doc.cuerpo.cs_id_171,this.model.doc.cuerpo.cs_id_172, true); 
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultado,this.model.doc.cuerpo.cs_id_173, true); 
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultado,this.model.doc.cuerpo.cs_id_174, true); 
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultado,this.model.doc.cuerpo.cs_id_175, true); 
    resultado = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultado, "0")?"0":resultado;
    this.model.doc.cuerpo.cs_id_148 = this.dutilidades.redondearValorMoneda(resultado,true);
    
  }

  operacionCs171(){
    this.model.doc.cuerpo.cs_id_171 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_171,true);
  }
  
  operacionCs172(){
    this.model.doc.cuerpo.cs_id_172 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_172,true);
  }
  
  operacionCs173(){
    this.model.doc.cuerpo.cs_id_173 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_173,true);
  }
  
  operacionCs174(){
    this.model.doc.cuerpo.cs_id_174 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_174,true);
  }
  
  operacionCs175(){
    this.model.doc.cuerpo.cs_id_175 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_175,true);
  }
  
 */  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
/*   public validateRbQuestions(val: string) {

  }
   */
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
/*   public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    return habilitado;
  }
 */
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
/*   public validateBtnRightActive(){

  } */

  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
    
  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    this.initializeTablaDesdeModelo();
    this.operacionCs168();
    //this.changeStepLocal(0);
    this.dialogRef.close("");
  }
  public guardar(){
    //Limpiar modelo y agregar el contenido de la tabla
    this.model.doc.cuerpo.cc_id_252 = undefined;
    this.inicializeModelo();
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }
    this.operacionCs168();
    this.saveModel.emit(true); 
    //if(this.indexStepper==this.stepsList.length-1){
    this.closeModal();
    //} 
  }
  public borrarTabla(){
    this.dataSourceBody = [];
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-deuda-nacional-modal/patrimonio-deuda-nacional-modal.component.ts